import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Container,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  addManufacturer,
  fetchCategories,
  getBrands,
  getManufacturer,
  updateManufacturer,
  deleteManufacturer,
} from "../Services/inventoryService";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import Footer from "../Footer/Footer";
import Swal from "sweetalert2";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
type OptionType = {
  id: number;
  label: string;
};

const ManufacturerManagement: React.FC = () => {
  const [categories, setCategories] = useState<OptionType[]>([]);
  const [brands, setBrands] = useState<OptionType[]>([]);
  const [manufacturers, setManufacturers] = useState<any[]>([]);

  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [selectedBrand, setSelectedBrand] = useState<string>("");

  const [newManufacturer, setNewManufacturer] = useState<string>("");
  const [openDialog, setOpenDialog] = useState(false);
  const [editManufacturer, setEditManufacturer] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const orgId = localStorage.getItem("orgId") || "";
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await fetchCategories(orgId);
        const formatted = response.map(
          (cat: { categoryId: number; categoryName: string }) => ({
            id: cat.categoryId,
            label: cat.categoryName,
          })
        );
        setCategories(formatted);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    loadCategories();
  }, []);

  useEffect(() => {
    const loadBrands = async () => {
      if (!selectedCategory) return;
      try {
        const response = await getBrands(orgId, selectedCategory);
        const formatted = response.map(
          (brand: { brandId: number; brandName: string }) => ({
            id: brand.brandId,
            label: brand.brandName,
          })
        );
        setBrands(formatted);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    loadBrands();
  }, [selectedCategory]);

  //   useEffect(() => {
  //     const loadManufacturers = async () => {
  //       if (!selectedBrand) return;
  //       try {
  //         const response = await getManufacturer(orgId,selectedBrand);
  //         const formatted = response.map((manufacturer: { manufacturerId: number; manufacturerName: string }) => ({
  //           id: manufacturer.manufacturerId,
  //           name: manufacturer.manufacturerName,
  //         }));
  //         setManufacturers(formatted);
  //       } catch (error) {
  //         console.error("Error fetching manufacturers:", error);
  //       }
  //     };
  //     loadManufacturers();
  //   }, [selectedBrand]);
  useEffect(() => {
    const loadManufacturers = async () => {
      if (!selectedBrand) return;
      try {
        const response = await getManufacturer(orgId, selectedBrand);
        const formatted = response.map((manufacturer: any) => ({
          id: manufacturer.manufacturerId,
          name: manufacturer.manufacturerName,
          status: manufacturer.status || "active",
          createdBy: manufacturer.createdBy || "N/A",
          createdDate: new Date(manufacturer.createdDate).toLocaleString(),
          updatedBy: manufacturer.updatedBy || "N/A",
          updatedDate: new Date(manufacturer.updatedDate).toLocaleString(),
        }));
        setManufacturers(formatted);
      } catch (error) {
        console.error("Error fetching manufacturers:", error);
      }
    };
    loadManufacturers();
  }, [selectedBrand]);

  //   const handleAddManufacturer = async () => {
  //     if (!newManufacturer.trim()) {
  //       alert("Please enter a manufacturer name.");
  //       return;
  //     }
  //     try {
  //         const createdBy="adminUser";
  //       const response = await addManufacturer(selectedBrand, newManufacturer,orgId,createdBy);
  //       if (response.success) {
  //         setManufacturers([...manufacturers, { id: response.manufacturerId, name: newManufacturer }]);
  //         setNewManufacturer("");
  //       } else {
  //         alert("Failed to add manufacturer.");
  //       }
  //     } catch (error) {
  //       console.error("Error adding manufacturer:", error);
  //     }
  //   };

  const handleAddManufacturer = async () => {
    if (!newManufacturer.trim()) {
      Swal.fire({
        title: "Error",
        text: "Please enter a manufacturer name.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      const createdBy = "adminUser";
      const response = await addManufacturer(
        selectedBrand,
        newManufacturer,
        orgId,
        createdBy
      );

      if (response.success) {
        const newManufacturerData = {
          id: response.manufacturerId,
          name: newManufacturer,
          status: "active",
          createdBy,
          createdDate: new Date().toLocaleString(),
          updatedBy: createdBy,
          updatedDate: new Date().toLocaleString(),
        };

        setManufacturers([...manufacturers, newManufacturerData]);
        setNewManufacturer("");
        Swal.fire({
          title: "Success",
          text: "Manufacturer added successfully.",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to add manufacturer.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error adding manufacturer:", error);
    }
  };

  const handleEditManufacturer = async () => {
    if (!editManufacturer) return;
    try {
      const response = await updateManufacturer(
        editManufacturer.id,
        editManufacturer.name,
        orgId,
        "adminUser"
      );
      if (response.success) {
        setManufacturers(
          manufacturers.map((m) =>
            m.id === editManufacturer.id
              ? { ...m, name: editManufacturer.name }
              : m
          )
        );
        setOpenDialog(false);
        Swal.fire({
          title: "Success",
          text: "Manufacturer has been updated.",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to update manufacturer.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating manufacturer:", error);
    }
  };

  const handleDeleteManufacturer = async (manufacturerId: string) => {
    const { isConfirmed } = await Swal.fire({
      title: "Delete Manufacturer?",
      text: "Are you sure you want to delete this manufacturer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!isConfirmed) return;

    try {
      const response = await deleteManufacturer(
        manufacturerId,
        orgId,
        "adminUser"
      );
      if (response.success) {
        setManufacturers(manufacturers.filter((m) => m.id !== manufacturerId));
        Swal.fire("Deleted!", "Manufacturer has been deleted.", "success");
      } else {
        Swal.fire("Error", "Failed to delete manufacturer.", "error");
      }
    } catch (error) {
      console.error("Error deleting manufacturer:", error);
      Swal.fire("Error", "Error deleting manufacturer.", "error");
    }
  };

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Manufacturer Name", width: 200 },
    { field: "status", headerName: "Status", width: 100 },
    { field: "createdBy", headerName: "Created By User", width: 150 },
    { field: "createdDate", headerName: "Created Date", width: 150 },
    { field: "updatedBy", headerName: "Updated By User", width: 150 },
    { field: "updatedDate", headerName: "Updated Date", width: 100 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <>
         {/* <Tooltip title="Edit">
         <IconButton
            startIcon={<EditIcon />}
            onClick={() => {
              setEditManufacturer({ id: params.row.id, name: params.row.name });
              setOpenDialog(true);
            }}
            sx={{ marginRight: 1 }}
          > 
           </IconButton>
          </Tooltip> */}
          <Tooltip title="Edit">
        <IconButton size="small" sx={{ padding: 0.5}}
          onClick={() => {
            setEditManufacturer({
              id: params.row.id,
              name: params.row.name,
            });
            setOpenDialog(true);
          }}
          
        >
          <EditIcon fontSize="small"  />
        </IconButton>
      </Tooltip>
          {/* <Tooltip title="Delete">
          <Button
            color="error"
            startIcon={<Delete />}
            onClick={() => handleDeleteManufacturer(params.row.id)}
          ></Button>
          </Tooltip> */}
           <Tooltip title="Delete">
        <IconButton
          color="error"
          onClick={() => handleDeleteManufacturer(params.row.id)}
        >
          <DeleteIcon  fontSize="small"/>
        </IconButton>
      </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      
        <div className="page-location">
          <span>Master &gt; Manufacturer Master</span>
        </div>
        <Container maxWidth="lg" sx={{ padding: 4 }}>
        <Box sx={{ padding: 4 }}>
          {/* <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "black",
              textTransform: "uppercase",
              textAlign: "center",
              marginBottom: 2,
              textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
          >
            Manufacturer Management
          </Typography> */}

          <Grid container spacing={2} alignItems="center">
            {/* Category */}
            <Grid item xs={12} md={4}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ justifyContent: "center" }}
              >
                <InputLabel id="select-category-label">
                  Select Category
                </InputLabel>
                <Select
                  value={selectedCategory}
                  labelId="select-category-label"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  label="Select Category"
                >
                  {categories.map((cat) => (
                    <MenuItem key={cat.id} value={cat.id}>
                      {cat.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Brand */}
            {selectedCategory && (
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Select Brand</InputLabel>
                  <Select
                    value={selectedBrand}
                    onChange={(e) => setSelectedBrand(e.target.value)}
                    label="Select Brand"
                  >
                    {brands.map((brand) => (
                      <MenuItem key={brand.id} value={brand.id}>
                        {brand.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Manufacturer Input */}
            {selectedBrand && (
              <Grid item xs={12} md={4}>
                <TextField
                  label="New Manufacturer"
                  variant="outlined"
                  value={newManufacturer}
                  onChange={(e) => setNewManufacturer(e.target.value)}
                  required
                  error={newManufacturer.trim() === ""}
                  // helperText={newManufacturer.trim() === "" ? "Required" : ""}
                  fullWidth
                />
              </Grid>
            )}

            {/* Add Manufacturer Button (Centered) */}
            {selectedBrand && (
              <Grid item xs={12} display="flex" justifyContent="center">
                <Button
                  variant="contained"
                  //startIcon={<AddIcon />}
                  onClick={handleAddManufacturer}
                  sx={{ mt: 2 }}
                >
                  {/* Add Manufacturer */}
                  Submit
                </Button>
              </Grid>
            )}

            {/* Data Grid */}
            {selectedBrand && (
              <Grid item xs={12}>
                <DataGrid
                  rows={manufacturers}
                  columns={columns}
                  pageSizeOptions={[5]}
                  autoHeight
                />
              </Grid>
            )}
          </Grid>

          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle>Edit Manufacturer</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Manufacturer Name"
                value={editManufacturer?.name || ""}
                onChange={(e) =>
                  setEditManufacturer((prev) =>
                    prev ? { ...prev, name: e.target.value } : null
                  )
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
              <Button variant="contained" onClick={handleEditManufacturer}>
                Update
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
      <Box
        sx={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
        }}
      >
        <Footer />
      </Box>
    </>
  );
};

export default ManufacturerManagement;
